import React, { useState, useContext, useEffect } from "react";
import {
  makeStyles,
  Grid,
  Typography,
  IconButton,
  Collapse,
  RootRef,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import { OptionCard, Paper, PopUp, Loader, Button } from "../components";
import {
  ProgramsIcon,
  DetailsIcon,
  SamplesIcon,
  CircleArrowBack,
  CircleArrowFowardIcon,
  ArrowBackIcon,
} from "../icons";
import { theme } from "../theme";
import { modals } from "../constants";
import { AuthContext, QuantityContext } from "../context";
import { doctorServices, labServices } from "../services";
import { useScroll, useResize } from "../hooks";

export default function SampleScreen(props) {
  const { state } = useLocation();
  const { product, productsList, hideQuantity, isPromo } = state;
  console.log("THIS PRODUCT IS: ", product);
  const { paperGrow, domRef, onScroll } = useScroll();
  const { collapseH } = useResize();
  const classes = useStyles({ hideQuantity, paperGrow, collapseH, ...props })();
  const [count, setCount] = useState(1);
  const [modal, setModal] = useState(false);
  const [modalName, setModalName] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const history = useHistory();
  const { authState, signOut } = useContext(AuthContext);
  const { quantityState } = useContext(QuantityContext);
  const [optionSelected, setOptionSelected] = useState(1);
  const [loading, setLoading] = useState(false);
  const [indexOpen, setIndexOpen] = useState(null);
  const matchesDesktop = useMediaQuery(useTheme().breakpoints.up("md"));
  const [modalError, setModalError] = useState(false);
  const [doctorKit, setDoctorKit] = useState([]);

  const isAssignBtnDisabled = () => {
    const statusToDisable = [
      "661822297b4df03548c403fa",
      "661822407b4df03548c403fb",
    ];

    return statusToDisable.includes(product.status?.toString());
  };

  useEffect(() => {
    async function init() {
      try {
        setLoading(true);
        const {
          status,
          response: { products: _doctorKit },
        } = await doctorServices.getDoctorKit({
          token: authState.token,
          _id: authState.user.doctor._id,
        });
        setLoading(false);
        if (status === 200) {
          setDoctorKit(_doctorKit.map(({ _id }) => _id));
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        setLoading(false);
        console.log("Error", e);
      }
    }
    init();
  }, [authState, signOut]);

  const goToAssign = () => {
    let aux = productsList.filter((elem) => elem.index !== product.index);
    aux.push({
      ...product,
      isSelect: true,
      quantityToAssign: count,
    });
    history.push({ pathname: "/assign", state: { products: aux } });
  };

  const requestSingleProduct = async () => {
    try {
      setModal(false);
      setLoading(true);
      const { status, response } = await labServices.addOrder({
        products: [{ _id: product._id }],
        token: authState.user.token,
        doctorId: authState.user.doctor._id,
      });
      setLoading(false);
      if (status === 201) {
        setModalMessage(response.message);
      } else if (status === 401) {
        signOut();
      } else {
        if (response.error) {
          if (response.error.code === 1015) {
            setModalMessage(response.error.message);
            setModalError(true);
          }
        }
        //console.log({error:true, status, response} )
      }
      setModalName(modals[2]);
      setModal(true);
    } catch (e) {
      setLoading(false);
      console.log("Error", e);
    }
  };

  return (
    <Grid container>
      <PopUp
        modalName={modalName}
        open={modal}
        setModal={() => setModal(!modal)}
        message={modalMessage}
        productToRequest={product}
        popToTop={"/request"}
        modalError={modalError}
        modalSubMessage={
          "Tu solicitud ha sido enviada al laboratorio, una vez aprobada, podrás disfrutar de tus muestras en el botiquín virtual"
        }
      />
      {loading && <Loader loading={true} />}
      {/* <Drawer /> */}
      <Grid container className={classes.container}>
        <Collapse
          in={!matchesDesktop ? !paperGrow : true}
          id={"collapseId"}
          timeout={500}
          style={{ width: "100%" }}
        >
          <Grid
            className={classes.headerContainer}
            container
            justify="space-between"
          >
            <Grid
              item
              md={3}
              lg={2}
              className={classes.containerImage}
              onClick={() => {
                setModalName(modals[4]);
                setModal(!modal);
              }}
            >
              <img src={product.logo} alt={product.name} />
            </Grid>
            <Grid
              item
              md={9}
              lg={10}
              container
              className={classes.desktopHeader}
              alignItems="center"
            >
              <Grid item md={2} lg={1}>
                <IconButton
                  style={{ padding: 0 }}
                  onClick={() => history.goBack()}
                >
                  <ArrowBackIcon />
                </IconButton>
              </Grid>
              <Grid item md={4} lg={2}>
                <Typography
                  style={{ fontWeight: "600" }}
                  component="h1"
                  variant="h1"
                  align="left"
                >
                  {product.name}
                </Typography>
              </Grid>
              <Grid item md={6} lg={9} container justify="flex-end">
                {!hideQuantity && (
                  <div className={classes.btn2} style={{}}>
                    <Typography variant="h6" component={"p"} display="flex">
                      <span>Cant.</span>
                      <span>{quantityState.quantity}</span>
                    </Typography>
                  </div>
                )}
              </Grid>
              <Grid item md={12}>
                <div className={classes.containerTitle}>
                  <Typography style={{ padding: 0, margin: "15px 0" }}>
                    {" "}
                  </Typography>
                </div>
              </Grid>
              <Grid
                item
                md={12}
                xs={8}
                container
                justify="flex-start"
                alignItems="center"
              >
                <Grid
                  container
                  className={classes.containerOption}
                  style={{ alignItems: "flex-start" }}
                  item
                  lg={1}
                  md={2}
                >
                  <IconButton
                    onClick={() => setOptionSelected(1)}
                    className={
                      optionSelected === 1 ? classes.optionSelected : ""
                    }
                    style={{ padding: 10, width: 45, height: 45 }}
                  >
                    <DetailsIcon selected={optionSelected === 1} />
                  </IconButton>
                  <Typography>Producto</Typography>
                </Grid>
                <Grid
                  container
                  className={classes.containerOption}
                  style={{ alignItems: "flex-start" }}
                  item
                  lg={1}
                  md={2}
                >
                  <IconButton
                    onClick={() => setOptionSelected(2)}
                    className={
                      optionSelected === 2 ? classes.optionSelected : ""
                    }
                    style={{ padding: 10, width: 45, height: 45 }}
                  >
                    <SamplesIcon selected={optionSelected === 2} />
                  </IconButton>
                  <Typography>Estudios</Typography>
                </Grid>
                <Grid
                  container
                  className={classes.containerOption}
                  style={{ alignItems: "flex-start" }}
                  item
                  lg={1}
                  md={2}
                >
                  <IconButton
                    onClick={() => setOptionSelected(3)}
                    className={
                      optionSelected === 3 ? classes.optionSelected : ""
                    }
                    style={{ padding: 10, width: 45, height: 45 }}
                  >
                    <ProgramsIcon selected={optionSelected === 3} />
                  </IconButton>
                  <Typography>Programas</Typography>
                </Grid>
                {!hideQuantity && (
                  <Grid
                    container
                    className={classes.controlQuantity}
                    style={{ alignItems: "flex-start", height: "unset" }}
                    item
                    lg={2}
                    md={3}
                  >
                    {product.assigned - product.used &&
                    !isAssignBtnDisabled() ? (
                      <>
                        <Grid container>
                          <CircleArrowBack
                            style={{
                              opacity: count > 1 ? 1 : 0.5,
                              cursor: "pointer",
                            }}
                            color={theme.palette.secondary.main}
                            onClick={
                              count > 1 ? () => setCount(count - 1) : () => {}
                            }
                          />
                          <div>
                            {product.assigned - product.used && (
                              <Typography>{count}</Typography>
                            )}
                          </div>
                          <CircleArrowFowardIcon
                            style={{
                              opacity:
                                count < product.assigned - product.used
                                  ? 1
                                  : 0.5,
                              cursor: "pointer",
                            }}
                            color={theme.palette.secondary.main}
                            onClick={
                              count < product.assigned - product.used
                                ? () => setCount(count + 1)
                                : () => {}
                            }
                          />
                        </Grid>
                        <Typography align="center">
                          Cant. para asignar
                        </Typography>
                      </>
                    ) : null}
                  </Grid>
                )}
                {!isPromo && (
                  <Grid
                    item
                    md={hideQuantity ? 9 : 3}
                    lg={hideQuantity ? 9 : 7}
                    container
                    justify="flex-end"
                  >
                    <Grid container className={classes.desktopSubmitButton}>
                      {doctorKit.includes(product._id) && hideQuantity ? (
                        <Button
                          disabled={loading}
                          onClick={() => history.push({ pathname: "/" })}
                        >
                          <Typography>
                            <b>MUESTRA DISPONIBLE EN BOTIQUÍN</b>
                          </Typography>
                        </Button>
                      ) : product.assigned - product.used &&
                        !isAssignBtnDisabled() ? (
                        <Button
                          disabled={loading}
                          onClick={
                            !hideQuantity ? goToAssign : requestSingleProduct
                          }
                        >
                          {loading
                            ? "Cargando..."
                            : // : !hideQuantity
                            product.assigned - product.used
                            ? "ASIGNAR"
                            : "SOLICITAR MUESTRA"}
                        </Button>
                      ) : null}
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <div
              className={`${classes.containerTitle} ${classes.containerTitle2}`}
            >
              <Typography> </Typography>
            </div>
          </Grid>
        </Collapse>
        <Paper className={classes.paperClass}>
          <Grid
            className={classes.desktopOptions}
            container
            justify="flex-start"
            alignItems="center"
          >
            <Grid
              container
              className={classes.containerOption}
              item
              xs={hideQuantity ? 4 : 2}
            >
              <IconButton
                onClick={() => setOptionSelected(1)}
                className={optionSelected === 1 ? classes.optionSelected : ""}
                style={{ padding: 10, width: 45, height: 45 }}
              >
                <DetailsIcon selected={optionSelected === 1} />
              </IconButton>
              <Typography>Producto</Typography>
            </Grid>
            <Grid
              container
              className={classes.containerOption}
              item
              xs={hideQuantity ? 4 : 3}
            >
              <IconButton
                onClick={() => setOptionSelected(2)}
                className={optionSelected === 2 ? classes.optionSelected : ""}
                style={{ padding: 10, width: 45, height: 45 }}
              >
                <SamplesIcon selected={optionSelected === 2} />
              </IconButton>
              <Typography>Estudios</Typography>
            </Grid>
            <Grid
              container
              className={classes.containerOption}
              item
              xs={hideQuantity ? 4 : 3}
            >
              <IconButton
                onClick={() => setOptionSelected(3)}
                className={optionSelected === 3 ? classes.optionSelected : ""}
                style={{ padding: 10, width: 45, height: 45 }}
              >
                <ProgramsIcon selected={optionSelected === 3} />
              </IconButton>
              <Typography>Programas</Typography>
            </Grid>
            {!hideQuantity && (
              <Grid container className={classes.controlQuantity} item xs={4}>
                {product.assigned - product.used && !isAssignBtnDisabled() && (
                  <>
                    <Grid container>
                      <CircleArrowBack
                        style={{ opacity: count > 1 ? 1 : 0.5 }}
                        color={theme.palette.secondary.main}
                        onClick={
                          count > 1 ? () => setCount(count - 1) : () => {}
                        }
                      />
                      <div>
                        {product.assigned - product.used && (
                          <Typography>{count}</Typography>
                        )}
                      </div>
                      <CircleArrowFowardIcon
                        style={{
                          opacity:
                            count < product.assigned - product.used ? 1 : 0.5,
                        }}
                        color={theme.palette.secondary.main}
                        onClick={
                          count < product.assigned - product.used
                            ? () => setCount(count + 1)
                            : () => {}
                        }
                      />
                    </Grid>
                    <Typography align="center">Cant. para asignar</Typography>
                  </>
                )}
              </Grid>
            )}
          </Grid>
          <RootRef rootRef={domRef}>
            <Grid
              container
              spacing={2}
              className={classes.scrollList}
              onScroll={onScroll}
            >
              {optionSelected === 1 ? (
                <>
                  {[
                    "Composición",
                    "Indicaciones",
                    // "Prospecto",
                    "Presentaciones",
                    "Concentración",
                    "Registro",
                    "Precio",
                    // "Vigencia",
                    // "Contraindicaciones",
                  ].map((value, index) => (
                    <Grid
                      item
                      xs={12}
                      key={index}
                      style={{ marginBottom: index === 8 ? 80 : 0 }}
                    >
                      <OptionCard
                        option={value}
                        product={product}
                        index={index}
                        open={indexOpen}
                        openCard={() =>
                          setIndexOpen(indexOpen === index ? null : index)
                        }
                      />
                    </Grid>
                  ))}
                  <Grid
                    item
                    xs={12}
                    key={6}
                    style={{ marginBottom: 6 === 8 ? 80 : 0 }}
                  >
                    <OptionCard
                      option={"Contraindicaciones"}
                      product={product}
                      index={6}
                      open={indexOpen}
                      openCard={() => {
                        setIndexOpen(indexOpen === 6 ? null : 6);
                      }}
                    />
                  </Grid>
                </>
              ) : optionSelected === 2 ? (
                product.clinicalStudies &&
                product.clinicalStudies.map((study, index) => (
                  <Grid item xs={12} key={index}>
                    <OptionCard
                      linkToFile
                      option={study.name}
                      product={product}
                      index={index}
                      open={null}
                      openCard={() =>
                        window.open(
                          `https://docs.google.com/viewer?url=${study.url}&print=true`
                        )
                      }
                    />
                  </Grid>
                ))
              ) : (
                product.richTextPrograms && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: product.richTextPrograms,
                    }}
                    align="justify"
                    style={{ color: "#192A7F" }}
                  />
                )
              )}
            </Grid>
          </RootRef>
        </Paper>
      </Grid>
      <Grid container className={classes.containerBtn}>
        {(!hideQuantity || product.status?.toString() !== "661822407b4df03548c403fb") && (
          <Button onClick={!hideQuantity ? goToAssign : requestSingleProduct}>
            {!hideQuantity ? "ASIGNAR A PACIENTE" : "SOLICITAR MUESTRA"}
          </Button>
        )}
      </Grid>
    </Grid>
  );
}

const useStyles = ({ hideQuantity, paperGrow, collapseH, ...props }) =>
  makeStyles((theme) => ({
    container: {
      display: "block",
      height: "100%",
      [theme.breakpoints.up("md")]: {
        padding: "50px 25px 0 25px",
      },
    },
    headerContainer: {
      alignItems: "center",
      padding: "30px 25px 25px",
      boxSizing: "border-box",
      [theme.breakpoints.up("md")]: {
        alignItems: "flex-start",
        padding: "0 25px",
        margin: "0 0 50px 0",
      },
    },
    containerImage: {
      width: 135,
      height: 135,
      boxSizing: "border-box",
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 4px 10px rgba(198, 198, 198, 0.5)",
      borderRadius: 20,
      padding: 13,
      "@media (min-width: 1024px) and (min-height: 1366px)": {
        width: "30%!important",
      },
      [theme.breakpoints.up("md")]: {
        width: "100%",
        height: "100%",
      },
      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "contain",
      },
    },
    desktopOptions: {
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    desktopHeader: {
      display: "none",
      "@media (min-width: 1024px) and (min-height: 1366px)": {
        width: "70%!important",
      },
      [theme.breakpoints.up("md")]: {
        display: "flex",
        width: "85%",
        padding: "0 0 0 40px",
      },
    },
    desktopSubmitButton: {
      [theme.breakpoints.up("lg")]: {
        justifyContent: "flex-end",
      },
      "& button": {
        [theme.breakpoints.up("lg")]: {
          width: "50%",
        },
      },
    },
    optionSelected: {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: "50%",
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
      },
    },
    containerTitle: {
      display: "none",
      width: "50%",
      justifyContent: hideQuantity ? "flex-start" : "space-around",
      flexDirection: "column",
      alignItems: "start",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
      "& p": {
        "-webkit-hyphens": "none",
        "-moz-hyphens": "none",
        fontSize: "1rem",
        lineHeight: "1.25rem",
        fontWeight: "500",
        color: theme.palette.primary.main,
        padding: "0 0 0 20px",
        overflowWrap: "break-word",
        wordWrap: "break-word",
        hyphens: "auto",
        width: "100%",
        boxSizing: "",
        //wordWrap: "normal",
      },
    },
    containerTitle2: {
      display: "flex",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    containerBtn: {
      position: "absolute",
      bottom: 90,
      padding: "0 12px",
      "& button": {
        [theme.breakpoints.up("md")]: {
          display: "none",
        },
      },
    },
    containerOption: {
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
      "& :nth-child(4)": {
        flexDirection: "row",
      },
      "& div": {
        "& p": {
          margin: 0,
        },
      },
      "& p": {
        fontSize: "0.688rem",
        lineHeight: "0.75rem",
        color: theme.palette.primary.main,
        fontWeight: "500",
        margin: "15px 0 0 0",
      },
    },
    controlQuantity: {
      height: 100,
      "& div:nth-child(1)": {
        justifyContent: "space-around",
        alignItems: "center",
        padding: "10px 0",
        "& div:nth-child(2)": {
          width: 49,
          height: 37,
          border: `2px solid ${theme.palette.secondary.main}`,
          boxSizing: "border-box",
          borderRadius: 25,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& p": {
            fontSize: "1rem",
            lineHeight: "1.25rem",
            fontWeight: "600",
            color: theme.palette.secondary.main,
          },
        },
      },
      "& > p": {
        width: "100%",
        fontSize: "0.688rem",
        lineHeight: "0.75rem",
        color: theme.palette.primary.main,
        fontWeight: "500",
        margin: "3px 0 0 0",
      },
    },
    btn2: {
      position: "relative",
      "& p": {
        // fontWeight: "600",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 4,
      },
      // "& span:nth-child(1)": {
      //   position: "absolute",
      //   left: -60,
      //   fontSize: "1rem",
      // },
      "& span:nth-child(2)": {
        // width: 50,
        // height: 50,
        borderRadius: "50%",
        backgroundColor: "#2196C0",
        padding: 12,
        color: "#FFF",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        aspectRatio: 1,
        height: "100%",
        // boxSizing: "border-box", //: "content-box",
      },
    },
    paperClass: {
      padding: "0 0 1rem 0",
      height: paperGrow ? "100%" : "calc(100% - 190px)",
      [theme.breakpoints.up("md")]: {
        height: `calc(100% - ${collapseH}px)`,
      },
    },
    scrollList: {
      margin: "0",
      width: "100%",
      height: `calc(100% - ${hideQuantity ? 90 : 180}px)`,
      overflowY: "scroll",
      paddingTop: 0,
      display: "block",
      [theme.breakpoints.up("md")]: {
        padding: "0 25px !important",
        height: "98%",
      },
      [theme.breakpoints.down("sm")]: {
        "&::-webkit-scrollbar": {
          width: "1px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0,0,0, .1)",
        },
      },
      "&::-webkit-scrollbar": {
        width: "4px",
        height: "8px",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.secondary.main,
        borderRadius: "10px",
      },
    },
  }));
